<article class="workspace-option" [class.modo-cambio]="esModoCambio()"
  [class.seleccionado]="esModoCambio() && seleccionado()" [class.activo]="esModoCambio() && activo()"
  (click)="alElegir()" (keydown.enter)="alElegir()"
  (keydown.space)="alElegir(); $event.preventDefault()"
  [attr.role]="esModoCambio() ? 'button' : null" [attr.tabindex]="esModoCambio() ? 0 : null"
  [attr.aria-pressed]="esModoCambio() ? seleccionado() : null">

  <div class="workspace-info">
    <div class="workspace-logo" aria-hidden="true">
      @if (workspace().logoUrl) {
      <img [src]="workspace().logoUrl" [alt]="workspace().name">
      } @else {
      <span>{{ inicial() }}</span>
      }
    </div>

    <div class="workspace-texts">
      <h3 class="workspace-name title-medium">{{ workspace().name }}</h3>
      @if (etiquetaRol()) {
      <span class="role-badge label-medium">{{ etiquetaRol() | translate }}</span>
      }
    </div>
  </div>

  @if (!esModoCambio()) {
  <div class="workspace-actions">
    @if (workspace().reciente) {
    <span class="recent-badge label-medium">
      <mat-icon class="badge-icon">schedule</mat-icon>
      {{ 'Reciente' | translate }}
    </span>
    }
    <button type="button" class="enter-button filled" (click)="alElegir(); $event.stopPropagation()"
      [attr.aria-label]="('Entrar a' | translate) + ' ' + workspace().name">
      {{ 'Entrar' | translate }}
    </button>
  </div>
  } @else {
  <mat-icon class="selection-indicator" [class.visible]="seleccionado()" aria-hidden="true">
    chevron_right
  </mat-icon>
  }
</article>
